import { curry } from 'ramda';
import { IAppState } from '../../redux';
import { IConfigState } from '../../redux/reducers';

export const selectConfigValue = curry(
  (key: keyof IConfigState, state: IAppState) => {
    return state.config[key];
  },
);
